<script>
export default {
  functional: true,

  render() {
    return (
      <svg
        width="120px"
        height="44px"
        viewBox="0 0 240 88"
        preserveAspectRatio="xMidYMid meet"
        style="transform: scale(1.5)"
      >
        <path
          class="infinity-loader__background"
          fill="none"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 				c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
        />
        <path
          class="infinity-loader__outline"
          fill="none"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 				c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
        />
      </svg>
    )
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

$loader--length: 242.776657104492px;
$loader--time: 1.6s;

.infinity-loader__outline {
  stroke-dasharray: $loader--length * 0.01, $loader--length;
  stroke-dashoffset: 0;
  animation: infinity-loader-animation $loader--time linear infinite;
  stroke: var(--brand-color-hex);
}

.infinity-loader__background {
  stroke: $color-ui--grey-20;
}

@keyframes infinity-loader-animation {
  12.5% {
    stroke-dasharray: $loader--length * 0.14, $loader--length;
    stroke-dashoffset: -$loader--length * 0.11;
  }
  43.75% {
    stroke-dasharray: $loader--length * 0.35, $loader--length;
    stroke-dashoffset: -$loader--length * 0.35;
  }
  100% {
    stroke-dasharray: $loader--length * 0.01, $loader--length;
    stroke-dashoffset: -$loader--length * 0.99;
  }
}
</style>
